import React from "react";
import FavoriteAthleteSearch from "../../common/athletes/FavoriteAthleteSearch";

function UniversityAthletes() {
  return (
    <>
      <FavoriteAthleteSearch />
    </>
  );
}

export default UniversityAthletes;
